import React from 'react';
import {
  TrainingFeaturesSection,
  SectionHeading,
  FeatureRows,
  FeatureRow,
  FeatureNumber,
  FeatureRowContent,
} from './Features.styles';

const Features = () => {
  return (
    <TrainingFeaturesSection>
      <SectionHeading>
        <p className="eyebrowHeader">Built for Employers</p>

        <h2>
          Less Training Administration.
          <br />
          More Visibility.
        </h2>

        <p>
          Give managers a clearer view of employee safety training without
          relying on separate spreadsheets, emails, and certificate folders.
        </p>
      </SectionHeading>

      <FeatureRows>
        <FeatureRow>
          <FeatureNumber>01</FeatureNumber>

          <FeatureRowContent>
            <h3>Assign the Right Training</h3>

            <p>
              Choose courses for the employees who need them and keep company
              training connected to one central account.
            </p>
          </FeatureRowContent>
        </FeatureRow>

        <FeatureRow>
          <FeatureNumber>02</FeatureNumber>

          <FeatureRowContent>
            <h3>See Who Has Done What</h3>

            <p>
              Review employee and course progress so you can quickly see
              completed training and outstanding assignments.
            </p>
          </FeatureRowContent>
        </FeatureRow>

        <FeatureRow>
          <FeatureNumber>03</FeatureNumber>

          <FeatureRowContent>
            <h3>Know When Training Is Completed</h3>

            <p>
              Receive updates when employees complete purchased training so
              important records do not disappear into individual inboxes.
            </p>
          </FeatureRowContent>
        </FeatureRow>

        <FeatureRow>
          <FeatureNumber>04</FeatureNumber>

          <FeatureRowContent>
            <h3>Keep Certificates Within Reach</h3>

            <p>
              Access employee training certificates through the company
              experience whenever documentation is needed.
            </p>
          </FeatureRowContent>
        </FeatureRow>
      </FeatureRows>
    </TrainingFeaturesSection>
  );
};

export default Features;
